module.exports = ".container {\r\n\twidth:100%;\r\n\tpadding:0;margin: 0;\r\n\tposition: relative;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main